module.exports = __webpack_public_path__ + "static/media/badge_blank.eb6d68ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/badge_blank.png
// module id = 275
// module chunks = 0